import { createReducer } from 'typesafe-actions'
import { TradeOrderSideEnum } from '@sparling/financial-common'
import {
  changeOrderSide,
  redirectTo,
  setAuthToken,
  setAuth2FAToken,
  unsetAuthToken,
  unsetAuth2FAToken,
} from '../actions'
import { ActionTypes } from '../types'

export type AppState = {
  authToken: string | null
  auth2FAToken: string | null
  orderSide: TradeOrderSideEnum
  redirectPath: string | null
}

export const initialState: AppState = {
  authToken: null,
  auth2FAToken: null,
  orderSide: TradeOrderSideEnum.BUY,
  redirectPath: null,
}

export const app = createReducer<AppState, ActionTypes>(initialState)
  .handleAction(setAuthToken, (state, { payload }) => ({
    ...state,
    authToken: payload,
  }))
  .handleAction(unsetAuthToken, (state) => ({
    ...state,
    authToken: null,
  }))
  .handleAction(changeOrderSide, (state, { payload }) => ({
    ...state,
    orderSide: payload,
  }))
  .handleAction(setAuth2FAToken, (state, { payload }) => ({
    ...state,
    auth2FAToken: payload,
  }))
  .handleAction(unsetAuth2FAToken, (state) => ({
    ...state,
    auth2FAToken: null,
  }))
  .handleAction(redirectTo, (state, { payload }) => ({
    ...state,
    redirectPath: payload,
  }))
